export default class BaseConcreteStrategy {
    chainId;
    ethereumChainId;
    listeners = {};
    constructor(args) {
        this.ethereumChainId = 'ethereumOptions' in args && args.ethereumOptions
            ? args.ethereumOptions.ethereumChainId
            : undefined;
        this.chainId = args.chainId;
    }
}
//# sourceMappingURL=base.js.map